/**
 * El nombre de una entrega, sin HTML. Es el título del método de envío que manda Magento, y
 * algunos traen HTML adentro —un link a "detalles", un `<br>`— que el admin mostraba como
 * texto, con las etiquetas a la vista. Se queda el texto ("…Consultar detalles"); el HTML no
 * se renderiza, porque viene de la configuración de cada tienda.
 *
 * `DOMParser` arma el documento sin ejecutar nada, así que es seguro para sacar el texto.
 */
export const nombreDeEntrega = (nombre?: string | null): string => {
  if (!nombre) return "";
  if (!/[<&]/.test(nombre)) return nombre.trim();
  const texto =
    new DOMParser().parseFromString(nombre, "text/html").body.textContent ??
    nombre;
  return texto.replace(/\s+/g, " ").trim();
};
